/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionTypeDetailsService } from '../services/subscription-type-details.service';
import { SubscriptionTypeEditService } from './subscription-type-edit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BackNavigationService } from '@irian-ro/shared-components-module';

@Component({
  selector: 'well-subscription-type-edit-page',
  templateUrl: './subscription-type-edit-page.component.html',
  styleUrls: ['./subscription-type-edit-page.component.scss'],
  providers: [{ provide: SubscriptionTypeDetailsService, useClass: SubscriptionTypeEditService }]

})
export class SubscriptionTypeEditPageComponent implements OnInit, OnDestroy {

  uuid: string | undefined = undefined;
  index = 0;
  unsubscribe: Subject<boolean> = new Subject<boolean>();

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private backNavigationService: BackNavigationService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      data => {
        this.uuid = data['uuid'];
      }
    )
    this.backNavigationService
      .getLatestRouterState()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((value: any) => {
        this.index = value?.index ?? 0;
       })
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
  }

}
